module.exports = __webpack_public_path__ + "img/slider_comments_3.68322a4e.jpg";